import React, { useState } from "react";
import { BASE_URL } from "../../utils/config";
import ReactSelect from "react-select";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
const FutureSection = ({
  stockSymbols,
  requestToken,
  commenteryData,
  isEditable,
  onFutureSectionChange,
  onFutureExpirySelect,
  onFutureStockSelect,
  onRemoveFile,
  onStockLossRecord
}) => {
  const [cmperror, setCmpError] = useState(false);
  const [futurecmperror, setFutureCmpError] = useState(false);
  const [slerror, setSlError] = useState(false);
  const [volumeError, setVolumeError] = useState(false);
  const [togglesymbol, setToggleSymbol] = useState(true);
  const options = stockSymbols.map(data => ({
    ...data,
    value: data.name,
    label: data.name
  }));

  const customStyles = {
    // Define your custom styles here
    menu: provided => ({
      ...provided,
      width: "256px",
      marginLeft: "205px"
    }),
    control: (provided, state) => ({
      ...provided,
      width: "256px", // Set the desired width for the entire component
      border: "1px solid #ccc",
      borderRadius: "4px",
      boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : null,
      "&:hover": {
        border: "1px solid #2684FF"
      }
    })
    // Add more styles for other elements as needed
  };

  const [futureSectionState, setFutureSectionState] = useState({
    futureReportType: "BUY",
    stockType: "",
    cashCMP: "",
    futureCMP: "",
    futureSL: "0",
    futureRemark:
      "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
    commentry: "",
    Expiry: "",
    imageData: "",
    base64Data: "",
    volume: ""
  });
  let RemarkText =
    "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.";
  const [futureSectionErrorMsz, setFutureSectionErrorMsz] = useState('');
  const [futureSectionError, setFutureSectionError] = useState(false);
  const [expiryData, setExpiryData] = useState([]);
  const [expiryRecord, setExpiryRecord] = useState([]);
  const [expiryshow, setexpiryshow] = useState(false);
  const [showCmpApiError, setShowCmpApiError] = useState(false);
  const [showFutureCmpApiError, setShowFutureCmpApiError] = useState(false);
  const [showFutureSLApiError, setShowFutureSLApiError] = useState(false);

  // this function is used change the input fields
  const handleInputChange = event => {
    setCmpError(false);
    setFutureCmpError(false);
    setSlError(false);
    const { name, value } = event.target;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setFutureSectionState(prevState => {
        let newState;
        if (name === "futureSL" && value === "0") {
          newState = {
            ...prevState,
            [name]: value,
            futureRemark: RemarkText
          };
        } else if (name === "futureSL" && value != "0") {
          newState = {
            ...prevState,
            [name]: value,
            futureRemark: ""
          };
        } else {
          newState = {
            ...prevState,
            [name]: value,
            futureRemark: ""
          };
        }

        // Log the updated state
        // console.log("futureSectionState", newState);

        // Notify the parent component about the change
        onFutureSectionChange(newState);

        return newState;
      });
    } else {
      if (name === "cashCMP") {
        setCmpError(true);
        setTimeout(() => {
          setCmpError(false);
        }, 2000);
      } else if (name === "futureCMP") {
        setFutureCmpError(true);
        setTimeout(() => {
          setFutureCmpError(false);
        }, 2000);
      } else if (name === "futureSL") {
        setSlError(true);
        setTimeout(() => {
          setSlError(false);
        }, 2000);
      } else if (name === "volume") {
        setVolumeError(true);
        setTimeout(() => {
          setVolumeError(false);
        }, 2000);
      }
    }
  };

  // handleChange function is used to handle the radio button change
  const handleChange = event => {
    const { name, value } = event.target;

    setFutureSectionState(prevState => {
      const newState = {
        ...prevState,
        [name]: value
      };

      // Log the updated state
      // console.log("futureSectionState", newState);

      // Notify the parent component about the change
      onFutureSectionChange(newState);

      return newState;
    });
  };

  //  handlechangestock function is used to handle the stock change
  const handlechangestock = async event => {
    // const { name, value } = event.target;

    // const { name, value } = event;
    console.log("event", event);
    const type = "NFO-FUT";

    setFutureSectionState(prevState => {
      const newState = {
        ...prevState,
        stockType: event.name,
        cashCMP: "",
        futureCMP: "",
        futureSL: "0",
        futureRemark:
          "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
        commentry: "",
        Expiry: "",
        imageData: "",
        volume: ""
      };

      onRemoveFile();

      const selectedStockRecord = stockSymbols.find(
        item => item.name === event.value
      );

      onFutureStockSelect(selectedStockRecord);
      onFutureSectionChange(newState);
      return newState;
    });

    await fetch(`${BASE_URL}/getstockexpiry/${event.value}/${type}`, {
      method: "GET"
    })
      .then(response => response.json())
      .then(res => {
        if (res.success === true) {
          let expiryData = JSON.parse(res.data[0].dates);
          let expiryRecord = JSON.parse(res.data[0].Kite_Data);

          console.log("expiryData", expiryData);

          setExpiryData(expiryData);
          setExpiryRecord(expiryRecord);
          setexpiryshow(true);
        }
        else {  
          setFutureSectionErrorMsz(`Error: ${res.message}`);
          setFutureSectionError(true);
          setTimeout(() => {
            
            setFutureSectionError(false);
            setFutureSectionErrorMsz('');
          }, 2000);
        }
      })
      .catch(error => {
        // Handle errors
        console.error("Error fetching data:", error);
        setFutureSectionErrorMsz(`Error: ${error.message}`);
          setFutureSectionError(true);
          setTimeout(() => {
            
            setFutureSectionError(false);
            setFutureSectionErrorMsz('');
          }, 2000);
      });
  };

  // handleStockChangeManual function is used to handle the stock change manually
  const handleStockChangeManual = async event => {
    const { name, value } = event.target;
    setFutureSectionState(prevState => {
      const newState = {
        ...prevState,
        [name]: value,
        cashCMP: "",
        futureCMP: "",
        futureSL: "0",
        futureRemark:
          "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
        commentry: "",
        Expiry: "",
        imageData: "",
        volume: ""
      };

      onRemoveFile();
      onFutureSectionChange(newState);
      return newState;
    });
  };

  // formatDate function is used to format the date
  const formatDate = dateString => {
    const dateObject = new Date(dateString);
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1; // Months are zero-based
    const year = dateObject.getFullYear();

    // Pad single-digit day and month with a leading zero
    const formattedDate = `${day < 10 ? "0" : ""}${day}-${month < 10
      ? "0"
      : ""}${month}-${year}`;

    return formattedDate;
  };

  // handlechangeExpiry function is used to handle the expiry change
  const handlechangeExpiry = async event => {
    const { name, value } = event.target;

    setFutureSectionState(prevState => {
      const newState = {
        ...prevState,
        [name]: value
      };

      // Log the updated state
      // console.log("futureSectionState", newState);

      // Notify the parent component about the change
      const selectedExpiryRecord = expiryData.find(
        item => item.expiry === value
      );
      // console.log("selectedExpiryRecord",selectedExpiryRecord)
      onFutureExpirySelect(selectedExpiryRecord);
      onFutureSectionChange(newState);

      return newState;
    });
  };

  // handleOptionChange function is used to handle the commentry  change
  const handleOptionChange = event => {
    const { name, value } = event.target;

    setFutureSectionState(prevState => {
      const newState = {
        ...prevState,
        [name]: value
      };

      onFutureSectionChange(newState);

      return newState;
    });
  };

  const IOSSwitch = styled(props =>
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  )(({ theme }) => ({
    width: 30,
    height: 14,
    padding: 0,
    margin: "0 5px 0 -55px",
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#23499E",
          opacity: 1,
          border: 0
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5
        }
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #23499E"
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600]
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3
      }
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 10,
      height: 10
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500
      })
    }
  }));

  // handleToogleSymbolChange function is used to handle the toggle symbol change  for fill all fields manually
  const handleToogleSymbolChange = event => {
    event.preventDefault();
    // console.log("event.target.checked", event.target.checked);
    setToggleSymbol(event.target.checked);
    setexpiryshow(false);
  };

  // handleExpiryChange function is used to handle the expiry change using calendar
  const handleExpiryChange = event => {
    console.log("event", event.target.value);
    const { name, value } = event.target;
    //  let date = formatDate(value)
    //  console.log("date")
    setFutureSectionState(prevState => {
      const newState = {
        ...prevState,
        [name]: value
      };

      onFutureSectionChange(newState);

      return newState;
    });
  };

  return (
    <div className="futuremain">
      <div id="btnfutureDiv" className="btnfuturediv">
        <p>BUY</p>
        <input
          type="radio"
          value="BUY"
          defaultChecked
          name="futureReportType"
          onChange={handleChange}
        />

        <p>Sell</p>
        <input
          type="radio"
          value="Sell"
          name="futureReportType"
          onChange={handleChange}
        />
      </div>

      <div id="future_content" className="futurecontent">
        <div>
          <p>
            Stock Name:<span className="asterisk">*</span>
          </p>
          <IOSSwitch
            sx={{ m: 1 }}
            defaultChecked
            checked={togglesymbol}
            onChange={handleToogleSymbolChange}
            inputProps={{ "aria-label": "controlled" }}
          />

          {togglesymbol
            ? <ReactSelect
                id="FutureStocktype"
                name="stockType"
                options={options}
                onChange={handlechangestock}
                styles={customStyles}
                disabled={!isEditable}
              />
            : <input
                value={futureSectionState.stockType}
                type="text"
                id="stockType"
                name="stockType"
                required
                onChange={handleStockChangeManual}
                disabled={!isEditable}
              />}
        </div>

        {togglesymbol
          ? expiryshow
            ? <div style={{ marginTop: "16px" }}>
                <p>
                  Expiry:<span className="asterisk">*</span>
                </p>
                <select
                  id="Futureexpiry"
                  name="Expiry"
                  onChange={handlechangeExpiry}
                  disabled={!isEditable}
                >
                  <option value="">Select Expiry</option>
                  {expiryData.map(expiry =>
                    <option key={expiry.instrument_token} value={expiry.expiry}>
                      {formatDate(expiry.expiry)}
                    </option>
                  )}
                </select>
              </div>
            : null
          : <div style={{ marginTop: "16px" }}>
              <p>
                Expiry:<span className="asterisk">*</span>
              </p>
              <input
                value={futureSectionState.Expiry}
                type="date"
                id="Expiry"
                name="Expiry"
                onChange={handleExpiryChange}
                disabled={!isEditable}
              />
            </div>}
        {cmperror
          ? <span style={{ color: "red", fontSize: "15px" }}>
              Numeric input with 2 decimal places (0-9).
            </span>
          : null}
        {showCmpApiError
          ? <span style={{ color: "red", fontSize: "15px" }}>
              Price Not Found.
            </span>
          : null}

        <div style={{ marginTop: "16px" }}>
          <p>
            UnderLying Price:<span className="asterisk">*</span>
          </p>

          <input
            value={futureSectionState.cashCMP}
            type="number"
            id="cashcmp"
            name="cashCMP"
            onChange={handleInputChange}
            disabled={!isEditable}
          />
        </div>

        {futurecmperror
          ? <span style={{ color: "red", fontSize: "15px" }}>
              Numeric input with 2 decimal places (0-9).
            </span>
          : null}
        {showFutureCmpApiError
          ? <span style={{ color: "red", fontSize: "15px" }}>
              Price Not Found.
            </span>
          : null}
        <div>
          <p>
            Future CMP:<span className="asterisk">*</span>
          </p>

          <input
            value={futureSectionState.futureCMP}
            type="number"
            id="futurecmp"
            name="futureCMP"
            onChange={handleInputChange}
            disabled={!isEditable}
          />
        </div>

        {slerror
          ? <span style={{ color: "red", fontSize: "15px" }}>
              Numeric input with 2 decimal places (0-9).
            </span>
          : null}
        {showFutureSLApiError
          ? <span style={{ color: "red", fontSize: "15px" }}>
              Price Not Found.
            </span>
          : null}

        <div>
          <p>
            SL :<span className="asterisk">*</span>
          </p>
          <input
            value={futureSectionState.futureSL}
            type="number"
            pattern="^[0-9]*$"
            id="FutureSL"
            name="futureSL"
            onChange={handleInputChange}
            disabled={!isEditable}
          />
        </div>

        {volumeError
          ? <span style={{ color: "red", fontSize: "15px" }}>
              Numeric input with 2 decimal places (0-9).
            </span>
          : null}

        <div>
          <p>Volume:</p>
          <input
            value={futureSectionState.volume}
            type="number"
            id="volume"
            name="volume"
            onChange={handleInputChange}
            disabled={!isEditable}
          />
        </div>

        <div>
          <p>
            Select commentary:<span className="asterisk">*</span>
          </p>
          <select
            id="selectcommentry"
            name="commentry"
            value={futureSectionState.commentry}
            onChange={handleOptionChange}
            disabled={!isEditable}
          >
            <option value="">Select commentary</option>
            {commenteryData.map(data =>
              <option
                className="commentery-option"
                key={data.CommentaryName}
                value={data.Description}
              >
                {data.CommentaryName}
              </option>
            )}
          </select>
        </div>

        <div>
          <p>Commentary Remarks:</p>
          <textarea
            style={{
              border: `2px solid ${futureSectionState.futureSL == "0"
                ? "red"
                : "rgba(0, 0, 0, 0.2)"}`,
              outline: "none"
            }}
            value={futureSectionState.futureRemark}
            id="futureremark"
            name="futureRemark"
            rows={4}
            onChange={handleChange}
            disabled={!isEditable}
          />
        </div>
      </div>

      <Dialog
        open={futureSectionError}
        onClose={() => {
          setFutureSectionError(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div>
              <span>
                <i
                  className="pi pi-exclamation-circle"
                  style={{ color: "#FF6060" }}
                />
                <br />
                {futureSectionErrorMsz}
              </span>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default FutureSection;
